<template>
  <div class="payments">
    <PageHeader :title="pageTitle" />

    <VLoader v-if="isLoading" />
    <div v-else>
      <VEmpty v-if="!payments[0]" />
      <div v-else>
        <Grid
          ref="grid"
          :data-items="payments"
          :columns="columns"
        >
        <template v-slot:status="{ props }">
            <td class="k-command-cell k-table-td">
                {{ renderStatus(props?.dataItem?.status) }}
            </td>
          </template>
          
          <template v-slot:payment_date="{ props }">
            <td class="k-command-cell k-table-td">
                {{ getFormatedDate(props?.dataItem?.payment_date || null) }}
            </td>
          </template>
          <template v-slot:created_at="{ props }">
            <td class="k-command-cell k-table-td">
                {{ getFormatedDate(props?.dataItem?.created_at || null) }}
            </td>
          </template>
          <template v-slot:updated_at="{ props }">
            <td class="k-command-cell k-table-td">
                {{ getFormatedDate(props?.dataItem?.updated_at || null) }}
            </td>
          </template>
          <template v-slot:client="{ props }">
            <td class="k-command-cell k-table-td">
                {{ renderClient(props?.dataItem?.client) }}
            </td>
          </template>
        </Grid>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

import { getMessageByLang } from "@/utils/translate.js";
import { getRespErrorMessage } from "@/utils/errors.js";
import { getFormatedDate } from '@/utils/date.js';
import { Grid } from "@progress/kendo-vue-grid";

import VLoader from "@/ui-kit/components/VLoader.vue";
import VEmpty from "@/ui-kit/components/VEmpty.vue";
import PageHeader from "@/components/page/PageHeader.vue";

import api from "@/api";

const isLoading = ref(true);
const payments = ref([]);

const statuses = {
  'pending': 'ожидание'
}

const pageTitle = getMessageByLang("paymentsText", "Платежи");
const columns = ref([
  {
    field: "order_id",
    title: 'ID',
  },
  {
    field: "amount",
    title: getMessageByLang("amountText", "Сумма"),
  },
  {
    field: "status",
    title: getMessageByLang("statusText", "Статус"),
    cell: 'status'
  },

  {
    field: "created_at",
    title: getMessageByLang("createdAtText", "Создано"),
    cell: 'created_at'
  },
  {
    field: "updated_at",
    title: getMessageByLang("updatedAtText", "Обновлено"),
    cell: 'updated_at'
  },
  {
    field: "client",
    title: 'Пользователь',
    cell: 'client'
  },
  {
    field: "comment",
    title: 'Комментарий',
  }
]);


const renderClient = (client) => {
  if(client) {
    return client.name;
  }

  return '';
}

const renderStatus = (status) => {
  if(statuses[status]) return statuses[status];

  return ''
}

const getPayments = async () => {
  try {
    isLoading.value = true;

    const response = await api.payments.getList();
    payments.value = response.data.data;

  } catch (err) {
    console.error(err);
    payments.value = [];

    const message = getRespErrorMessage(err);
    alert(message);

  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  getPayments();
});
</script>